/* eslint-disable react/prop-types */
import { Drawer } from "antd";
import React, { CSSProperties, FunctionComponent } from "react";

import { topNavHeightPx } from "../Constants/StyleConstants";

/**
 * See this page for the API of the "Drawer" component.
 *
 * UTL: https://3x.ant.design/components/drawer/
 */

interface SideNavProps {
    onCloseCallback: () => void;
    placement: "left" | "top" | "right" | "bottom";
    visible: boolean;
    width: string;
    bodyStyle?: CSSProperties;
    mask: boolean;
    maskClosable: boolean;
    closeable?: boolean;
}

export const SideNav: FunctionComponent<SideNavProps> = ({
    children,
    onCloseCallback,
    placement,
    visible,
    width,
    bodyStyle,
    mask,
    maskClosable,
    closeable
}): JSX.Element => {

    const onDrawerClose = (): void => {
        onCloseCallback();
    };

    return (
        <Drawer
            placement={placement}
            /** show the close "x" or not */
            closable={closeable}
            onClose={onDrawerClose}
            visible={visible}
            /** the width of the dialog itself (does NOT include the "mask") */
            width={width}
            /** the overlay on the rest of the screen */
            mask={mask}
            /** click outside to close the modal */
            maskClosable={maskClosable}
            /** NOTE: GB
             *
             * Any height or width attribute here will affect the mask!
             */
            style={{
                position: "absolute",
                top: topNavHeightPx,
                left: placement === "left" && 0,
                right: placement === "right" && 0,
                height: `calc(100% - ${topNavHeightPx}px)`,
                overflow: "auto",
                pointerEvents: visible ? 'auto' : 'none',
                minWidth: width,
            }}
            bodyStyle={{
                ...bodyStyle,
                width: width,
                height: "100%"
            }}>
            {children}
        </Drawer>
    );
};
